import { API_BASE_URL } from "../urls.api";
import { Node } from "@/pages/users/details/details-customer/components/nodes/nodes.types";

export const getGraphByOwner = async (ownerId: string): Promise<Node[]> => {
  const graphResponse = await fetch(`${API_BASE_URL}/nodes/graph/${ownerId}`, {
    method: "get",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  });
  const { data: graphData } = await graphResponse.json();

  // Solo devolver los nodos sin contadores - los contadores se manejarán en el componente
  return graphData;
};

export const createNode = async (node: Node): Promise<Node> => {
  const response = await fetch(`${API_BASE_URL}/nodes`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(node),
  });
  const { data } = await response.json();
  return data;
};

export const updateNodeContent = async (nodeId: string, node: Partial<Node>): Promise<Node> => {
  const response = await fetch(`${API_BASE_URL}/nodes/${nodeId}/content`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(node),
  });
  const { data } = await response.json();
  return data;
};

export const deleteNode = async (nodeId: string): Promise<Node> => {
  const response = await fetch(`${API_BASE_URL}/nodes/${nodeId}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `Failed to delete node: ${response.status} - ${errorData.message || "Unknown error"}`
    );
  }

  const { data } = await response.json();
  return data;
};

export const moveNode = async (nodeId: string, linkId: string): Promise<Node> => {
  const response = await fetch(`${API_BASE_URL}/nodes/${nodeId}/link/${linkId}`, {
    method: "PATCH",
    credentials: "include",
  });
  const { data } = await response.json();
  return data;
};

export const checkRoomLicense = async (roomId: string): Promise<boolean> => {
  const response = await fetch(`${API_BASE_URL}/nodes/subscriptions/${roomId}/room`, {
    method: "GET",
    credentials: "include",
  });
  const { data } = await response.json();
  return data;
};

export const checkOwnerLicense = async (ownerId: string): Promise<boolean> => {
  const response = await fetch(`${API_BASE_URL}/nodes/subscriptions/${ownerId}/owner`, {
    method: "GET",
    credentials: "include",
  });
  const { data } = await response.json();
  return data;
};

export const checkManagerLicense = async (managerId: string): Promise<boolean> => {
  const response = await fetch(`${API_BASE_URL}/nodes/subscriptions/${managerId}/manager`, {
    method: "GET",
    credentials: "include",
  });
  const { data } = await response.json();
  return data;
};

interface ManagerGraphData {
  ownerId: string;
  clientName: string;
  graphs: Node[];
}

export const getManagerGraphs = async (managerId: string): Promise<ManagerGraphData[]> => {
  const response = await fetch(`${API_BASE_URL}/nodes/graph/manager/${managerId}`, {
    method: "GET",
    credentials: "include",
  });
  const { data } = await response.json();

  // Solo devolver los grafos sin contadores - los contadores se manejarán en el componente
  return data;
};

export const activateGraph = async (ownerId: string): Promise<ActivateGraphResponse> => {
  const response = await fetch(`${API_BASE_URL}/nodes/graph/owner/${ownerId}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
    (error as any).statusCode = response.status;
    throw error;
  }

  const data = await response.json();
  return data;
};

export interface ActivateGraphResponse {
  data: {
    acknowledged: boolean;
    insertedCount: number;
    insertedIds: {
      [key: string]: string;
    };
  };
}
